const TrainerSimulazioni = (props) => {
  const { simulazioni } = props;
  return (
    <div className="trainer-simulazioni">
      <div className="trainer-simulazioni-title">Simulazioni</div>
      <div className="trainer-data-fields">
        {simulazioni.length > 0 ? (
          simulazioni.map((sim) => (
            <div key={sim.idSimulazioneTrainer} className="trainer-data">
              <div className="field-row">
                <div className="field-label">Link</div>
                <div className="field-value">
                  <span className="span-value">
                    <a
                      href={sim.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {sim.link}
                    </a>
                  </span>
                </div>
              </div>

              <div className="field-row">
                <div className="field-label">Autore</div>
                <div className="field-value">
                  <span className="span-value">{sim.autore}</span>
                </div>
              </div>

              <div className="field-row">
                <div className="field-label">Data inserimento</div>
                <div className="field-value">
                  <span className="span-value">
                    {sim.dataInserimento
                      ? (() => {
                          const d = new Date(sim.dataInserimento);
                          const day = String(d.getDate()).padStart(2, "0");
                          const month = String(d.getMonth() + 1).padStart(
                            2,
                            "0"
                          );
                          const year = d.getFullYear();
                          return `${day}.${month}.${year}`;
                        })()
                      : ""}
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-data">Nessuna simulazione disponibile.</div>
        )}
      </div>
    </div>
  );
};

export default TrainerSimulazioni;
